import { useEffect, useRef } from 'react';

const useIntersectionObserver = (ref, callback, options = {}) => {
  const hasTriggered = useRef(false);

  useEffect(() => {
    const handleIntersection = (entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && !hasTriggered.current) {
          callback(entry);
          hasTriggered.current = true;
          observer.unobserve(entry.target);
        }
      });
    };

    const observer = new IntersectionObserver(handleIntersection, options);

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => {
      if (observer && ref.current) {
        observer.unobserve(ref.current);
      }
    };
  }, [ref, callback, options]);
};

export default useIntersectionObserver;
